export const menuItems = [
    {id: "1", name: "Doručak", items: [
        {
            id: "1",
            name: "Omlet sir",
            options: ["Tost hleb", "3 jaja", "feta sir", "salata", "paradajz"],
            price: "290",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Omlet šunka",
            options: ["Tost hleb", "3 jaja", "šunka", "feta sir", "salata", "paradajz"],
            price: "340",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Omlet slanina",
            options: ["Tost hleb", "3 jaja", "slanina", "feta sir", "salata", "paradajz"],
            price: "370",
            imgUrl: "../assets/doručak/Omlet-slanina.jpg"
        },
        {
            id: "4",
            name: "Omlet pečenica",
            options: ["Tost hleb", "3 jaja", "pečenica", "kačkavalj", "feta sir", "salata", "paradajz"],
            price: "350",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Memories doručak",
            options: ["Tost hleb", "3 jaja na oko", "pančeta", "feta sir", "salata", "paradajz"],
            price: "400",
            imgUrl: "../assets/doručak/Memories-dorucak.jpg"
        },
        {
            id: "6",
            name: "Proteinski omlet",
            options: ["Tost hleb", "3 jaja", "spanać", "salata", "paradajz"],
            price: "380",
            imgUrl: "../assets/doručak/Proteinski-omlet.jpg"
        },
        {
            id: "7",
            name: "Crostini jaja",
            options: ["Tost hleb", "3 jaja", "pršuta", "pavlaka", "cherry"],
            price: "380",
            imgUrl: "../assets/doručak/Crostini-jaja.jpg"
        },
        {
            id: "8",
            name: "Crostini jaja - veća",
            options: ["Tost hleb", "4 jaja", "pršuta", "pavlaka", "cherry"],
            price: "480",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Jaja sa kobasicama",
            options: ["Tost hleb", "3 jaja", "kobasice", "tartar", "paradajz", "feta sir"],
            price: "500",
            imgUrl: "../assets/doručak/jaja-sa-kobasicama.jpg"
        },
        {
            id: "10",
            name: "Jaja sa viršlama",
            options: ["Tost hleb", "3 jaja", "viršle", "tzatziki", "paradajz", "feta sir"],
            price: "440",
            imgUrl: ""
        },
        {
            id: "11",
            name: "Ovsena kaša",
            options: ["Mleko", "lešnik", "badem", "čokolada", "banana", "džem"],
            price: "330",
            imgUrl: "../assets/doručak/ovsena-kasa.jpg"
        },
        {
            id: "12",
            name: "Ovsena kaša (posna)",
            options: ["Sojino mleko", "lešnik", "badem", "čokolada", "banana", "džem"],
            price: "390",
            imgUrl: ""
        },
        {
            id: "13",
            name: "Prženice",
            options: ["Tost hleb", "Gauda", "šunka", "jaja", "pavlaka"],
            price: "310",
            imgUrl: "../assets/doručak/Przenice.jpg"
        },
        {
            id: "14",
            name: "Pomfrit porcija 300g",
            price: "280",
            imgUrl: ""
        },
        {
            id: "15",
            name: "Pekarski krompir porcija 300g",
            price: "320",
            imgUrl: ""
        },
        {
            id: "16",
            name: "Hleb",
            price: "60",
            imgUrl: ""
        },
        {
            id: "17",
            name: "Jaje",
            price: "60",
            imgUrl: ""
        }
    ]},
    {id: "2", name: "Toplo predjelo", items: [
        {
            id: "1",
            name: "Meza plata 300g",
            options: ["Pohovani kačkavalj", "pohovani luk", "pršuta", "gorgonzola", "masline"],
            price: "850",
            imgUrl: "../assets/toplo predjelo/meza-plata.jpg"
        },
        {
            id: "2",
            name: "Pohovani kačkavalj 300g",
            price: "490",
            imgUrl: "../assets/toplo predjelo/Pohovani-kackavalj.jpg"
        },
        {
            id: "3",
            name: "Pohovani luk 300g",
            price: "310",
            imgUrl: "../assets/toplo predjelo/pohovani-luk.jpg"
        },
        {
            id: "4",
            name: "Grilovani šampinjoni 300g",
            price: "420",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Grilovano sezonsko povrće 400g",
            options: ["Paprika", "tikvice", "cherry", "crni luk", "šampinjoni", "šargarepa", "susam", "soja sos"],
            price: "490",
            imgUrl: ""
        }
    ]},
    {id: "3", name: "Pohovane palačinke", items: [
        {
            id: "1",
            name: "Pizza palačinka",
            options: ["Šunka", "kačkavalj", "pečurke", "origano", "kečap", "pavlaka"],
            price: "420",
            imgUrl: "../assets/pohovane palacinke/Pizza-palacika.jpg"
        },
        {
            id: "2",
            name: "Šunka",
            options: ["Šunka", "kačkavalj", "kečap", "pavlaka", "majonez"],
            price: "360",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Pršuta",
            options: ["Pršuta", "kačkavalj", "kečap", "pavlaka", "majonez"],
            price: "420",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Memories",
            options: ["Pršuta", "spanać", "feta sir", "pavlaka"],
            price: "430",
            imgUrl: "../assets/pohovane palacinke/Memories-palacinka.jpg"
        },
        {
            id: "5",
            name: "Pečenica",
            options: ["Pečenica", "kačkavalj", "pavlaka", "kečap", "majonez"],
            price: "390",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Pileća",
            options: ["Piletina", "šunka", "krastavčići", "pavlaka", "majonez", "senf"],
            price: "450",
            imgUrl: "../assets/pohovane palacinke/Palacinka-pileca.jpg"
        }
    ]},
    {id: "4", name: "Slatke palačinke", items: [
        {
            id: "1",
            name: "Eurokrem, šlag",
            price: "260",
            imgUrl: "../assets/slatke palacinke/Eurokrem-slag.jpg"
        },
        {
            id: "2",
            name: "Eurokrem, plazma, šlag",
            price: "290",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Eurokrem, plazma, banana, šlag",
            price: "310",
            imgUrl: "../assets/slatke palacinke/Eurokrem-plazma-banana-slag.jpg"
        },
        {
            id: "4",
            name: "Eurokrem, plazma, malina, šlag",
            price: "350",
            imgUrl: "../assets/slatke palacinke/Eurokrem-plazma-malina-slag.jpg"
        },
        {
            id: "5",
            name: "Eurokrem, plazma, višnja, šlag",
            price: "350",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Rafaelo",
            options: ["Beli eurokrem", "lešnik", "kokos", "slatka pavlaka", "šlag", "karamela"],
            price: "370",
            imgUrl: "../assets/slatke palacinke/Rafaelo.jpg"
        },
        {
            id: "7",
            name: "Nutela",
            options: ["Nutela", "šlag"],
            price: "320",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Nutela plazma",
            options: ["Nutela", "plazma", "šlag"],
            price: "340",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Pistaći",
            options: ["Pistaći krem", "šlag"],
            price: "440",
            imgUrl: "../assets/slatke palacinke/Pistaci.jpg"
        },
        {
            id: "10",
            name: "Kapri",
            options: ["Bela čokolada", "jagoda", "šlag"],
            price: "390",
            imgUrl: "../assets/slatke palacinke/Kapri-palacinka.jpg"
        },
        {
            id: "11",
            name: "Jaffa",
            options: ["Nutela", "pomorandža", "plazma", "šlag"],
            price: "390",
            imgUrl: ""
        },
        {
            id: "12",
            name: "Pistaći malina",
            options: ["Bela čokolada", "pistaći", "malina", "plazma", "šlag"],
            price: "500",
            imgUrl: ""
        },
        {
            id: "13",
            name: "Dodatak jagoda",
            price: "90",
            imgUrl: ""
        },
        {
            id: "14",
            name: "Dodatak malina",
            price: "90",
            imgUrl: ""
        },
        {
            id: "15",
            name: "Dodatak pomorandža",
            price: "90",
            imgUrl: ""
        },
        {
            id: "16",
            name: "Dodatak banana",
            price: "70",
            imgUrl: ""
        },
        {
            id: "17",
            name: "Dodatak plazma",
            price: "60",
            imgUrl: ""
        },
        {
            id: "16",
            name: "Dodatak šlag",
            price: "60",
            imgUrl: ""
        }
    ]},
    {id: "5", name: "Sendviči", items: [
        {
            id: "1",
            name: "Club sendvič",
            options: ["Tost hleb", "piletina", "pančeta", "jaje", "zelena salata", "paradajz", "pavlaka", "burger sos", "pomfrit"],
            price: "490",
            imgUrl: "../assets/sendviči/Klub-sendvic.jpg"
        },
        {
            id: "2",
            name: "Memories sendvič",
            options: ["Tost hleb", "pančeta", "gauda", "jaje", "zelena salata", "paradajz", "pavlaka", "pomfrit"],
            price: "390",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Sendvič sa spanaćem",
            options: ["Tost hleb", "jaje", "pečenica", "spanać", "pavlaka", "beli luk"],
            price: "290",
            imgUrl: "../assets/sendviči/sendvic-sa-spanacem.jpg"
        }
    ]},
    {id: "6", name: "Paste", items: [
        {
            id: "1",
            name: "Karbonara",
            options: ["Pene", "pančeta", "neutralna pavlaka", "gauda", "parmezan", "beli luk", "jaja"],
            price: "550",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Dimljena piletina",
            options: ["Pene", "dimljena piletina", "neutralna pavlaka", "gordonzola"],
            price: "510",
            imgUrl: "../assets/paste/Pasta-dimljena-piletina.jpg"
        },
        {
            id: "3",
            name: "Pršuta u krem sosu",
            options: ["Pene", "pršuta", "neutralna pavlaka", "crni luk", "šargarepa", "tikvice", "timijan"],
            price: "560",
            imgUrl: "../assets/paste/Prsuta-u-krem-sosu.jpg"
        },
        {
            id: "4",
            name: "Rižoto piletina",
            options: ["Pirinač", "piletina", "nšargarepa", "kukuruz", "grašak", "pavlaka za kuvanje"],
            price: "480",
            imgUrl: "../assets/paste/Rizoto-piletina.jpg"
        },
        {
            id: "5",
            name: "Rižoto povrće (posno)",
            options: ["Pirinač", "šargarepa", "kukuruz šećerac", "grašak", "crni luk", "paradajz sos"],
            price: "430",
            imgUrl: ""
        }
    ]},
    {id: "7", name: "Piletina", items: [
        {
            id: "1",
            name: "Carski prsti",
            options: ["Piletina", "pomfrit", "salata mix", "burger sos", "cherry"],
            price: "630",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Grilovana piletina u krem sosu",
            options: ["Piletina", "pomfrit", "salata", "pavlaka za kuvanje"],
            price: "660",
            imgUrl: "../assets/piletina/Piletina-u-krem-sosu.jpg"
        },
        {
            id: "3",
            name: "Pileća Cezar rolnica",
            options: ["Tortilja", "pileće belo meso", "pančeta", "salata", "Cezar dresing", "paradajz"],
            price: "540",
            imgUrl: "../assets/piletina/Cezar-rolnice.jpg"
        },
        {
            id: "4",
            name: "Šefova piletina",
            options: ["Piletina", "pršuta", "krem sos", "grilovano povrće", "pekarski krompir"],
            price: "760",
            imgUrl: "../assets/piletina/Sefova-piletina.jpg"
        },
        {
            id: "5",
            name: "Tortilja sa piletinom",
            options: ["Piletina", "mix salata", "čeri", "tzatziki sos", "pomfrit", "čedar sir"],
            price: "610",
            imgUrl: "../assets/piletina/tortilja-piletina.jpg"
        },
        {
            id: "6",
            name: "Piletina u kari sosu",
            options: ["Piletina", "kari", "biber", "riža"],
            price: "740",
            imgUrl: "../assets/piletina/piletina-u-kari-sosu.jpg"
        },
        {
            id: "7",
            name: "Azijska riža",
            options: ["Pirinač", "piletina", "crni luk", "paprika", "ljuti sos", "susam"],
            price: "650",
            imgUrl: "../assets/piletina/azijska-riza.jpg"
        },
    ]},
    {id: "8", name: "Kobasica", items: [
        {
            id: "1",
            name: "Domaće kobasice 500g",
            options: ["Kobasice", "pekarski krompir", "burger sos", "luk"],
            price: "880",
            imgUrl: "../assets/kobasice/Kobasice.jpg"
        },
        {
            id: "2",
            name: "Domaće kobasice 250g",
            options: ["Kobasice", "pekarski krompir", "burger sos", "luk"],
            price: "550",
            imgUrl: ""
        }
    ]},
    {id: "9", name: "Salate", items: [
        {
            id: "1",
            name: "Cezar",
            options: ["Pileće belo meso", "pančeta", "mešana salata", "cherry", "parmezan", "majonez", "pavlaka", "krutoni"],
            price: "630",
            imgUrl: "../assets/salate/Cezar-salata.jpg"
        },
        {
            id: "2",
            name: "Tuna (posno)",
            options: ["Tuna komadi", "tuna dresing", "mešana salata", "cherry", "masline", "kukuruz", "krutoni"],
            price: "540",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Vitaminska",
            options: ["Pileće belo meso", "jaje", "mešana salata", "kukuruz", "pasulj", "cvekla", "šargarepa", "dresing"],
            price: "540",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Grčka",
            options: ["Krastavac", "paprika", "paradajz", "luk", "masline", "feta sir", "origano"],
            price: "310",
            imgUrl: "../assets/salate/Grcka-salata.jpg"
        },
    ]},
    {id: "10", name: "Burgeri", items: [
        {
            id: "1",
            name: "Burger",
            options: ["Burger zemička", "100% junetina", "burger sos", "crveni luk", "gauda"],
            price: "530",
            imgUrl: "../assets/burgeri/Burger.jpg"
        },
        {
            id: "2",
            name: "Chicken burger",
            options: ["Burger zemička", "pohovana piletina", "burger sos", "zelena salata", "paradajz", "pomfrit"],
            price: "480",
            imgUrl: "../assets/burgeri/Ciken-burger.jpg"
        },
        {
            id: "3",
            name: "Klasik chicken burger",
            options: ["Burger zemička", "piletina", "pohovani luk", "čedar sir", "krastavčići", "pomfrit"],
            price: "530",
            imgUrl: "../assets/burgeri/klasik-ciken.jpg"
        },
        {
            id: "4",
            name: "Argentina style burger",
            options: ["Junetina", "pohovani luk", "burger sos", "čedar sir", "salate", "kečap", "pomfrit"],
            price: "590",
            imgUrl: "../assets/burgeri/argentina-burger.jpg"
        },
        {
            id: "5",
            name: "Grčki burger",
            options: ["Juneće meso", "feta", "salata", "krastavac", "paradajz", "pavlaka", "crveni luk"],
            price: "530",
            imgUrl: "../assets/burgeri/Grcki-burger.jpg"
        }
    ]},
    {id: "11", name: "Kafe i topli napici", items: [
        {
            id: "1",
            name: "Espresso",
            price: "160",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Turska black 'n' easy",
            price: "130",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Nes caffe",
            price: "190",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Topla čokolada",
            price: "220",
            options: ["bela", "crna"],
            imgUrl: ""
        },
        {
            id: "5",
            name: "Milk shake plazma",
            price: "250",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Milk shake jagoda",
            price: "240",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Milk shake vanila",
            price: "240",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Milk shake čokolada",
            price: "240",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Milford čaj",
            price: "150",
            imgUrl: ""
        },
        {
            id: "10",
            name: "Neskvik",
            price: "220",
            imgUrl: ""
        },
        {
            id: "11",
            name: "Plazma, šlag",
            price: "50",
            imgUrl: ""
        }
    ]},
    {id: "12", name: "Sokovi negazirani", items: [
        {
            id: "1",
            name: "Next narandža 0,2",
            price: "240",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Next jagoda 0,2",
            price: "240",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Next jabuka 0,2",
            price: "240",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Next breskva 0,2",
            price: "240",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Next šumsko voće 0,2 borovnica",
            price: "240",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Cedevita",
            price: "150",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Orangina",
            price: "250",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Limun jagoda",
            price: "220",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Limun ananas",
            price: "220",
            imgUrl: ""
        },
        {
            id: "10",
            name: "Giffard limunada",
            price: "310",
            imgUrl: ""
        },
        {
            id: "11",
            name: "Homemade ice tea",
            price: "330",
            imgUrl: ""
        }
    ]},
    {id: "13", name: "Sveže ceđeno", items: [
        {
            id: "1",
            name: "Limunada",
            price: "230",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Ceđena pomorandža",
            price: "290",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Ceđeni grejp",
            price: "290",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Fresh mix",
            price: "330",
            imgUrl: ""
        }
    ]},
    {id: "14", name: "Voda", items: [
        {
            id: "1",
            name: "Rosa 0,33",
            price: "160",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Rosa gazirana 0,33",
            price: "160",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Romerquelle limunska trava 0,33",
            price: "220",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Vrnjci",
            price: "130",
            imgUrl: ""
        }
    ]},
    {id: "15", name: "Sokovi gazirani", items: [
        {
            id: "1",
            name: "Coca Cola 0,25",
            price: "240",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Coca Cola zero 0,25",
            price: "240",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Coca Cola lime 0,25",
            price: "240",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Fanta 0,25",
            price: "240",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Sprite 0,25",
            price: "240",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Schweppes bitter 0,25",
            price: "240",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Schweppes Tangerine 0,25",
            price: "240",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Schweppes tonic 0,25",
            price: "240",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Schweppes Mojito/Pink 0,25",
            price: "240",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Schweppes Purple 0,25",
            price: "220",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Ledeni čaj",
            price: "240",
            imgUrl: ""
        },
        {
            id: "10",
            name: "Three Cents Tonic",
            price: "360",
            imgUrl: ""
        },
        {
            id: "11",
            name: "Three Cents Aegean",
            price: "360",
            imgUrl: ""
        },
        {
            id: "12",
            name: "Three Cents Lemon",
            price: "360",
            imgUrl: ""
        },
        {
            id: "13",
            name: "Three Cents Pink Soda",
            price: "360",
            imgUrl: ""
        },
    ]},
    {id: "16", name: "Energetska pića", items: [
        {
            id: "1",
            name: "Ultra 0,25",
            price: "240",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Red bull 0,25",
            price: "350",
            imgUrl: ""
        }
    ]},
    {id: "17", name: "Whisky", items: [
        {
            id: "1",
            name: "Jack Daniels 0,03",
            price: "300",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Chivas 0,03",
            price: "340",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Jameson 0,03",
            price: "240",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Johnnie Walker 0,03",
            price: "230",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Balantines 0,03",
            price: "190",
            imgUrl: ""
        }
    ]},
    {id: "18", name: "Vodka", items: [
        {
            id: "1",
            name: "Smirnof 0,03",
            price: "210",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Vodka Atlantic",
            price: "140",
            imgUrl: ""
        }
    ]},
    {id: "19", name: "Kokteli", items: [
        {
            id: "1",
            name: "Gin tonic pink",
            price: "310",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Gin tonic limeta",
            price: "290",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Blue lagoon",
            price: "400",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Cosmopolitan",
            price: "410",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Sex on the beach",
            price: "410",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Memories coctail",
            price: "420",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Devils Ice Tea",
            price: "500",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Long Island",
            price: "460",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Pina Colada",
            price: "540",
            imgUrl: ""
        },
        {
            id: "10",
            name: "Black Sabbath",
            price: "480",
            imgUrl: ""
        },
        {
            id: "11",
            name: "Bahama Breezer",
            price: "480",
            imgUrl: ""
        },
        {
            id: "12",
            name: "Mai Tai",
            price: "540",
            imgUrl: ""
        },
        {
            id: "13",
            name: "Melon Martini",
            price: "460",
            imgUrl: ""
        },
        {
            id: "14",
            name: "Tekila Sunrise",
            price: "450",
            imgUrl: ""
        },
        {
            id: "15",
            name: "Tangueray gin tonic",
            price: "330",
            imgUrl: ""
        },
        {
            id: "16",
            name: "Passion fruit gin tonic",
            price: "290",
            imgUrl: ""
        },
        {
            id: "17",
            name: "Blue frog",
            price: "510",
            imgUrl: ""
        },
    ]},
    {id: "20", name: "Alkoholna pića", items: [
        {
            id: "1",
            name: "Gorki list 0,03",
            price: "150",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Jager 0,03",
            price: "200",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Vinjak 0,03",
            price: "140",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Vermouth",
            price: "150",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Brendy Badel",
            price: "150",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Štok 84",
            price: "140",
            imgUrl: ""
        },
        {
            id: "7",
            name: "GMG gin",
            price: "140",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Courvoisier 0,03",
            price: "270",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Campari 0,03",
            price: "210",
            imgUrl: ""
        },
        {
            id: "10",
            name: "Two fingers 0,03",
            price: "210",
            imgUrl: ""
        },
        {
            id: "11",
            name: "Bailes 0,03",
            price: "240",
            imgUrl: ""
        },
        {
            id: "12",
            name: "Absinthe 0,03",
            price: "210",
            imgUrl: ""
        },
        {
            id: "13",
            name: "Martini bianco 0,03",
            price: "170",
            imgUrl: ""
        }
    ]},
    {id: "21", name: "Rakije", items: [
        {
            id: "1",
            name: "Šljiva Zekić 0,03",
            price: "150",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Viljamovka Zekić 0,03",
            price: "170",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Dunjevača Zekić 0,03",
            price: "170",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Kajsija Zekić 0,03",
            price: "210",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Kruška Zekić 0,03",
            price: "160",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Bombay Sapphire",
            price: "230",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Šljivovača Voćar",
            price: "180",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Kajsija Voćar",
            price: "220",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Dunja Voćar",
            price: "220",
            imgUrl: ""
        },
        {
            id: "10",
            name: "Viljamovka Voćar",
            price: "210",
            imgUrl: ""
        },
        {
            id: "11",
            name: "Lozovača Voćar",
            price: "180",
            imgUrl: ""
        },
        {
            id: "12",
            name: "Malinovača Voćar",
            price: "430",
            imgUrl: ""
        }
    ]},
    {id: "22", name: "Pivo", items: [
        {
            id: "1",
            name: "Tuborg 0,33",
            price: "270",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Lav premium 0,33",
            price: "220",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Carlsberg 0,33",
            price: "280",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Lav premium točeno 0,5",
            price: "260",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Erdinger 0,30",
            price: "440",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Budweiser 0,33",
            price: "310",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Budweiser tamno 0,33",
            price: "310",
            imgUrl: ""
        },
        {
            id: "8",
            name: "San Migel 0,33",
            price: "440",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Somersby 0,33",
            options: ["Mango", "Borovnica", "Jabuka", "Kruška"],
            price: "310",
            imgUrl: ""
        },
        {
            id: "10",
            name: "Blanc 1664",
            price: "240",
            imgUrl: ""
        },
        {
            id: "11",
            name: "Blanc točeno",
            price: "270",
            imgUrl: ""
        },
        {
            id: "12",
            name: "Kronenburg",
            price: "260",
            imgUrl: ""
        },
        {
            id: "13",
            name: "Kronenburg točeno 0,5",
            price: "310",
            imgUrl: ""
        },
        {
            id: "14",
            name: "Tuborg Ice",
            price: "260",
            imgUrl: ""
        }
    ]},
    {id: "23", name: "Vino", items: [
        {
            id: "1",
            name: "Bonaca 0,187",
            price: "390",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Nostalgija 0,187",
            price: "380",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Barbara 0,187",
            price: "400",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Sangria 0,187",
            price: "350",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Žuti Cvet 0,187",
            price: "400",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Vranac 0,187",
            price: "390",
            imgUrl: ""
        },
    ]},
    {id: "24", name: "Doja vino", items: [
        {
            id: "1",
            name: "Doja prokupac 0,75",
            price: "2250",
            imgUrl: ""
        },
        {
            id: "2",
            name: "Doja tamjanika 0,75",
            price: "2550",
            imgUrl: ""
        },
        {
            id: "3",
            name: "Doja belo 0,75",
            price: "2150",
            imgUrl: ""
        },
        {
            id: "4",
            name: "Doja rose 0,75",
            price: "2050",
            imgUrl: ""
        },
        {
            id: "5",
            name: "Prokupac breg 0,75",
            price: "4450",
            imgUrl: ""
        },
        {
            id: "6",
            name: "Cabernet breg 0,75",
            price: "5600",
            imgUrl: ""
        },
        {
            id: "7",
            name: "Chardoney baric 0,75",
            price: "2950",
            imgUrl: ""
        },
        {
            id: "8",
            name: "Cabernet merlot 0,75",
            price: "2650",
            imgUrl: ""
        },
        {
            id: "9",
            name: "Enigma white 0,75",
            price: "1550",
            imgUrl: ""
        }
    ]}
];